import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-damage-support-doc',
    templateUrl: './damage-support-doc.component.html',
    styleUrls: ['./damage-support-doc.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DamageSupportDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
